import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import convertHttpErrorToLocal from 'src/utils/convertHttpErrorToLocal';
import { toTitle } from 'src/utils/toTitleCase';
import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable()
export class LoginService {

  constructor(private http: HttpClient,
    private sessionStorage: SessionStorageService) { }

  async login(user: string, password: string): Promise<{token: string, expireIn: string, isAdmin: boolean,language:string, name: string,refreshToken:string}> {
    try {


      const result = await (this.http.post(`${environment.baseUrl}/login/jwt`, {user, password}).toPromise() as Promise<any>);
      if (!result) {
        throw new Error("Could not retrieve data from login request");
      }
      if (typeof result.isAdmin !== "boolean") {
        console.warn("Had to set admin flag with false");
        result.isAdmin = false;
      }
      if (result.isAdmin && user !== "lourenco.depaula@alfa17.com.br" && user !== "thiago.dutra@alfa17.com.br") {
        console.error(result);
        console.error("Server returned isAdmin for a unexpected user");
        result.isAdmin = false;
      } else if (!result.isAdmin && (user === "lourenco.depaula@alfa17.com.br" || user === "thiago.dutra@alfa17.com.br")) {
        console.log(result);
        console.log("User " + user + " is expected to be admin, but server did send flag as such\n");
      }
      if (!result.name) {
        console.warn("User name was not present in the request!");
        result.name = toTitle(user.split('@')[0].replace(/[^a-zA-Z0-9]/g, ' ').trim());
      }

      return result;
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  getAuthorizationHeader() {
    return {Authorization: 'Bearer ' + window.sessionStorage.getItem('refreshToken')};
  }

  async renew(): Promise<{token: string, expireIn: string, isAdmin: boolean,language:string, name: string,refreshToken:string}> {
    try {
      this.http.head
      const result = await (this.http.post(`${environment.baseUrl}/login/jwt/renew`,{},{
        headers: this.getAuthorizationHeader()
      }).toPromise() as Promise<any>);
      if (!result) {
        throw new Error("Could not retrieve data from login request");
      }
      if (typeof result.isAdmin !== "boolean") {
        console.warn("Had to set admin flag with false");
        result.isAdmin = false;
      }

      return result;
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async forgotPassword(email: string, token: string): Promise<true> {
    try {
      return await (this.http.post(`${environment.baseUrl}/user/password/forgot`, {email, token}).toPromise() as Promise<any>);
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }

  async changeForgottenPassword(password: string, repeatPassword: string, token: string): Promise<true> {
    try {
      return await (this.http.post(`${environment.baseUrl}/user/password/reset`, {password, repeatPassword, token}).toPromise() as Promise<any>);
    } catch(err) {
      convertHttpErrorToLocal(err);
    }
  }
}
